import React from 'react';
import Select, { components } from 'react-select';
import jQuery from 'jquery';
import makeAnimated from 'react-select/animated'
import Helping from '../../helpers/Helping';

let updateCallback = (res) => {
}

export const setFilterValue = (callback) => {
    updateCallback = callback;
}

const animatedComponents = makeAnimated();

const DropDown = ({
    id,
    field,
    name,
    valuesArray,
    callback,
    selectChangeFunction,
    userSelectedFieldValue
}) =>

    <Select
        id={id}
        className="basic-multi-select"
        classNamePrefix="form-select"
        isSearchable={true}
        isClearable={false}
        name={name}
        defaultValue={userSelectedFieldValue}
        isMulti
        components={animatedComponents}
        placeholder={`Select ${Helping.getTitleCase(field)}...`}
        options={valuesArray}
        ref={ref => callback(name, ref)}
        onChange={(e) => {
            selectChangeFunction(e, name);
            if (e)
                updateCallback(e.value);
        }}

        formatOptionLabel={function (data) {
            return (
                <span dangerouslySetInnerHTML={{ __html: data.label }} />
            );
        }}
    />

export default DropDown;